import { FC } from 'react';
import { IconButton } from '../iconButton';
import closeIcon from 'assets/icons/small-close-icon.svg';
import closeWhiteIcon from 'assets/icons/small-close-white-icon.svg';

interface SmallCloseIconButtonProps {
	onClick?: () => void;
	variant?: 'default' | 'white';
}

export const SmallCloseIconButton: FC<SmallCloseIconButtonProps> = ({
	onClick,
	variant,
}) => {
	return (
		<IconButton
			role="close-button"
			iconSrc={variant === 'white' ? closeWhiteIcon : closeIcon}
			styles={{ iconHeight: '12px', width: '16px', height: '16px' }}
			onClick={onClick}
		/>
	);
};
